import styled from 'styled-components'

const Section = styled.section`
  min-height: calc(100% - 5.125rem);
  margin: 5.125rem 0 0 0;
`

export default Section
